(function($) {

    //* Make sure JS is enabled
    document.documentElement.className = "js";

    // function overflowOn(){
    //     $("html").css("overflow-y", "hidden");
    //     $("#contact-overlay .contact-content").css("overflow-y", "scroll");
    // }

    // function overflowOff(){
    //     $("html").css("overflow-y", "auto");
    //     $("#contact-overlay .contact-content").css("overflow-y", "hidden");
    // }

    $(document).ready(() => {
        const tl = new TimelineLite();

        $(".start-project").click((event) => {
            event.preventDefault();
            
            // $("html").css("position", "fixed");
            $("#contact-overlay").addClass("active");
            $("header, .content, footer").addClass("blurred");
            tl.to("#contact-overlay", 0.3, {  x: "-100%", ease: Power4.easeOut })
            .from("#contact-overlay .close", 0.3, {opacity:0, x: "+=50", delay:0.3, ease: Power2.easeInOut, onComplete(){
                $("html").css("overflow-y", "hidden");
                $("#contact-overlay .contact-content").css("overflow-y", "scroll");
            }})
            .to("#contact-overlay .close", 0.15, {className: "+=open"});
            $('.sumome-share-client-wrapper').fadeOut();
            // Tawk_API.hideWidget();

        });
        $('#contact-overlay .close, #contact-overlay .click-zone').click((event) => {
            event.preventDefault();
            
            // $("html").css("position", "static");
            $("#contact-overlay").removeClass("active");
            $("header, .content, footer").removeClass("blurred");
            $('.sumome-share-client-wrapper').show();
            tl.to("#contact-overlay .close", 0.15, {className: "-=open", onComplete(){
                $("html").css("overflow-y", "auto");
                $("#contact-overlay .contact-content").css("overflow-y", "hidden");
            }})
            .to("#contact-overlay", 0.3, { x: "100%", ease: Power4.easeIn });
            // Tawk_API.showWidget();
        });
    });
})(jQuery);
